import React from 'react';

import * as BaseC from './_ccmBaseC';
import * as _cr from './_cr';
import { useNgnz } from './_csNgn';
import * as _gv from './_gv';
import * as _ht from './_ht';
import * as _hm from './_hm';

import * as icm from './icm';
import * as icv from './icv';

export const N = (pz: {
  boxStlz?: _ht.dz,
  children: React.FC
}) => {

  const _sNgnz = useNgnz();
  const _gUserz = _gv.useUserz();

  return (
    _cr.c(BaseC.N, {
      abtz: {
        btnIconz: icv.abtz.btnIconz,
        textTtlz: icv.abtz.textTtlz,
      },
      cz: {
        ttl: _gUserz.crt._10rz._pfx ? `${_gUserz.crt._10rz._pfx} 様`: '',
        goHome: async () => {
          _sNgnz.setPageName('icvHomeM10Rz');
        },
        lot: () => icm.lot(_sNgnz),
      },
      boxStlz: pz.boxStlz,
    },
      pz.children
    )
  )
};
